export const translations = {
  es: {
    nav: {
      home: "Inicio",
      profile: "Perfil",
      career: "Trayectoria",
      goalkeepers: "Porteros",
      methodology: "Metodología",
      education: "Formación",
      references: "Referencias",
      contact: "Contacto",
      cta: "CONTACTO",
    },
    hero: {
      badge: "PRO GOALKEEPER COACH · LICENCIA PRO",
      name: "ROBERT PRIETO",
      subtitle: "ENTRENADOR PROFESIONAL DE PORTEROS",
      quote: "Desarrollando porteros para las exigencias del fútbol moderno.",
      viewCareer: "VER TRAYECTORIA",
      contact: "CONTACTAR",
      scroll: "Desplazar",
    },
    impact: {
      title: "IMPACTO PROFESIONAL",
      subtitle: "Una carrera construida al más alto nivel del fútbol profesional chileno.",
      stats: [
        { value: 15, prefix: "+", label: "AÑOS EN EL FÚTBOL PROFESIONAL" },
        { value: 7, prefix: "+", label: "CLUBES PROFESIONALES" },
        { value: 30, prefix: "+", label: "PORTEROS PROFESIONALES ENTRENADOS" },
        { value: 3, prefix: "", label: "CLASIFICACIONES CONSECUTIVAS A COPA SUDAMERICANA — UNIVERSIDAD CATÓLICA" },
        { value: 2, prefix: "", label: "CLASIFICACIONES A COPA SUDAMERICANA — DEPORTES ANTOFAGASTA" },
      ],
    },
    profile: {
      eyebrow: "PERFIL",
      title: "PERFIL PROFESIONAL",
      paragraphs: [
        "Entrenador profesional de porteros con amplia experiencia en el fútbol profesional chileno, especializado en la formación, el desarrollo y la optimización del rendimiento de porteros de élite.",
        "Su metodología integra desarrollo técnico, comprensión táctica, preparación física, entrenamiento cognitivo y análisis de rendimiento.",
        "Su enfoque conecta el proceso de entrenamiento con las exigencias reales de la competencia, creando entornos que promueven la toma de decisiones, el aprendizaje continuo y el desarrollo integral del portero moderno.",
      ],
      pillars: ["RENDIMIENTO", "DESARROLLO", "COMPETENCIA"],
    },
    career: {
      eyebrow: "TRAYECTORIA",
      title: "TRAYECTORIA DEPORTIVA",
      subtitle: "Ocho clubes profesionales. Más de una década construyendo porteros en la elite.",
      untilLabel: "Hasta",
    },
    goalkeepers: {
      eyebrow: "PORTEROS",
      title: "PORTEROS ENTRENADOS",
      intro:
        "A lo largo de su carrera profesional, Robert Prieto ha trabajado con porteros internacionales, profesionales consolidados y talentos emergentes.",
      filters: {
        all: "TODOS",
        international: "INTERNACIONALES",
        first: "PRIMERA DIVISIÓN",
        developed: "PORTEROS DESARROLLADOS",
      },
      currentClub: "Club actual",
      nationalTeam: "Selección",
      empty: "No hay porteros en esta categoría.",
    },
    development: {
      eyebrow: "FORMACIÓN",
      title: "FORMACIÓN DE PORTEROS",
      headline: "Desarrollando la próxima generación.",
      body: "Más allá del rendimiento en primera división, Robert Prieto ha participado en el desarrollo de porteros que han llegado desde el fútbol formativo a los primeros equipos y selecciones juveniles nacionales.",
    },
    methodology: {
      eyebrow: "METODOLOGÍA",
      title: "MODELO DE RENDIMIENTO DEL PORTERO",
      intro:
        "El portero ya no es solo responsable de defender el arco. El portero moderno debe entender el juego, gestionar el espacio, participar en la construcción, tomar decisiones bajo presión e influir en el rendimiento colectivo del equipo.",
      pillars: [
        {
          n: "01",
          title: "RENDIMIENTO TÉCNICO",
          items: ["Blocajes", "Vuelos", "1v1", "Centros", "Juego de pies", "Distribución"],
        },
        {
          n: "02",
          title: "COMPRENSIÓN TÁCTICA",
          items: [
            "Posicionamiento",
            "Gestión del espacio",
            "Organización defensiva",
            "Lectura del juego",
            "Participación en la salida",
          ],
        },
        {
          n: "03",
          title: "RENDIMIENTO FÍSICO",
          items: ["Fuerza explosiva", "Velocidad", "Potencia", "Movilidad", "Prevención de lesiones"],
        },
        {
          n: "04",
          title: "RENDIMIENTO COGNITIVO",
          items: ["Percepción", "Toma de decisiones", "Reacción", "Anticipación", "Resolución de problemas"],
        },
        {
          n: "05",
          title: "ANÁLISIS DE RENDIMIENTO",
          items: [
            "Análisis de video",
            "Evaluación del entrenamiento",
            "Análisis de partidos",
            "Planes individuales de desarrollo",
            "Feedback de rendimiento",
          ],
        },
        {
          n: "06",
          title: "TRANSFERENCIA A COMPETENCIA",
          items: [
            "Entornos de entrenamiento diseñados para reproducir las exigencias reales, la presión y las situaciones de decisión de la competencia profesional.",
          ],
        },
      ],
    },
    process: {
      title: "DEL ANÁLISIS AL RENDIMIENTO",
      steps: [
        "EVALUACIÓN DEL JUGADOR",
        "DIAGNÓSTICO DE RENDIMIENTO",
        "PLAN INDIVIDUAL DE DESARROLLO",
        "DISEÑO DE ENTRENAMIENTO",
        "PREPARACIÓN DE PARTIDO",
        "REVISIÓN DE RENDIMIENTO",
      ],
    },
    education: {
      eyebrow: "FORMACIÓN",
      title: "FORMACIÓN Y CERTIFICACIONES",
    },
    references: {
      eyebrow: "REFERENCIAS",
      title: "REFERENCIAS PROFESIONALES",
      privacy:
        "Referencias profesionales e información de contacto directo disponibles bajo solicitud.",
      groups: { coach: "CUERPOS TÉCNICOS", management: "DIRECCIÓN DEPORTIVA" },
    },
    media: {
      eyebrow: "MEDIA",
      title: "DENTRO DEL TRABAJO",
      empty: "Contenido multimedia próximamente.",
    },
    contact: {
      eyebrow: "CONTACTO",
      title: "ABIERTO A NUEVOS PROYECTOS PROFESIONALES",
      body: "Disponible para conectar con clubes de fútbol, cuerpos técnicos y organizaciones deportivas interesadas en el desarrollo de porteros y entornos de alto rendimiento.",
      sendEmail: "ENVIAR EMAIL",
      whatsapp: "WHATSAPP",
      downloadCv: "DESCARGAR CV",
      form: {
        name: "Nombre",
        organization: "Organización / Club",
        position: "Cargo",
        email: "Email",
        phone: "Teléfono",
        message: "Mensaje",
        send: "ENVIAR MENSAJE",
        success: "Mensaje enviado. Gracias por escribir.",
        error: "Ocurrió un error. Inténtalo nuevamente.",
      },
    },
    footer: {
      role: "ENTRENADOR PROFESIONAL DE PORTEROS",
      rights: "Todos los derechos reservados.",
    },
    admin: {
      login: "Acceder",
      loginTitle: "Panel de Administración",
      email: "Email",
      password: "Contraseña",
      logout: "Cerrar sesión",
    },
  },
  en: {
    nav: {
      home: "Home",
      profile: "Profile",
      career: "Career",
      goalkeepers: "Goalkeepers",
      methodology: "Methodology",
      education: "Education",
      references: "References",
      contact: "Contact",
      cta: "CONTACT",
    },
    hero: {
      badge: "PRO GOALKEEPER COACH · PRO LICENSE",
      name: "ROBERT PRIETO",
      subtitle: "PROFESSIONAL GOALKEEPER COACH",
      quote: "Developing goalkeepers for the demands of modern football.",
      viewCareer: "VIEW CAREER",
      contact: "CONTACT",
      scroll: "Scroll",
    },
    impact: {
      title: "PROFESSIONAL IMPACT",
      subtitle: "A career built at the highest level of Chilean professional football.",
      stats: [
        { value: 15, prefix: "+", label: "YEARS IN PROFESSIONAL FOOTBALL" },
        { value: 7, prefix: "+", label: "PROFESSIONAL CLUBS" },
        { value: 30, prefix: "+", label: "PROFESSIONAL GOALKEEPERS COACHED" },
        { value: 3, prefix: "", label: "CONSECUTIVE COPA SUDAMERICANA QUALIFICATIONS — UNIVERSIDAD CATÓLICA" },
        { value: 2, prefix: "", label: "COPA SUDAMERICANA QUALIFICATIONS — DEPORTES ANTOFAGASTA" },
      ],
    },
    profile: {
      eyebrow: "PROFILE",
      title: "PROFESSIONAL PROFILE",
      paragraphs: [
        "Professional Goalkeeper Coach with extensive experience in Chilean professional football, specialized in the training, development and performance optimization of elite goalkeepers.",
        "His methodology combines technical development, tactical understanding, physical preparation, cognitive training and performance analysis.",
        "His approach connects the training process with the real demands of competition, creating environments that promote decision-making, continuous learning and the complete development of the modern goalkeeper.",
      ],
      pillars: ["PERFORMANCE", "DEVELOPMENT", "COMPETITION"],
    },
    career: {
      eyebrow: "CAREER",
      title: "CAREER TIMELINE",
      subtitle: "Eight professional clubs. Over a decade building goalkeepers at the elite level.",
      untilLabel: "Until",
    },
    goalkeepers: {
      eyebrow: "GOALKEEPERS",
      title: "GOALKEEPERS COACHED",
      intro:
        "Throughout his professional career, Robert Prieto has worked with experienced international goalkeepers, established professionals and emerging talents.",
      filters: {
        all: "ALL",
        international: "INTERNATIONAL",
        first: "FIRST DIVISION",
        developed: "DEVELOPED GOALKEEPERS",
      },
      currentClub: "Current club",
      nationalTeam: "National team",
      empty: "No goalkeepers in this category.",
    },
    development: {
      eyebrow: "DEVELOPMENT",
      title: "GOALKEEPER DEVELOPMENT",
      headline: "Developing the next generation.",
      body: "Beyond first-team performance, Robert Prieto has participated in the development of goalkeepers who progressed from academy football to professional teams and national youth selections.",
    },
    methodology: {
      eyebrow: "METHODOLOGY",
      title: "GOALKEEPER PERFORMANCE MODEL",
      intro:
        "The goalkeeper is no longer only responsible for defending the goal. The modern goalkeeper must understand the game, manage space, participate in possession, make decisions under pressure and influence the collective performance of the team.",
      pillars: [
        {
          n: "01",
          title: "TECHNICAL PERFORMANCE",
          items: ["Handling", "Diving", "1v1 situations", "Crosses", "Footwork", "Distribution"],
        },
        {
          n: "02",
          title: "TACTICAL UNDERSTANDING",
          items: [
            "Positioning",
            "Space management",
            "Defensive organization",
            "Game reading",
            "Participation in build-up",
          ],
        },
        {
          n: "03",
          title: "PHYSICAL PERFORMANCE",
          items: ["Explosive strength", "Speed", "Power", "Mobility", "Injury prevention"],
        },
        {
          n: "04",
          title: "COGNITIVE PERFORMANCE",
          items: ["Perception", "Decision-making", "Reaction", "Anticipation", "Problem solving"],
        },
        {
          n: "05",
          title: "PERFORMANCE ANALYSIS",
          items: [
            "Video analysis",
            "Training evaluation",
            "Match analysis",
            "Individual development plans",
            "Performance feedback",
          ],
        },
        {
          n: "06",
          title: "COMPETITION TRANSFER",
          items: [
            "Training environments designed to reproduce the real demands, pressure and decision-making situations of professional competition.",
          ],
        },
      ],
    },
    process: {
      title: "FROM ANALYSIS TO PERFORMANCE",
      steps: [
        "PLAYER ASSESSMENT",
        "PERFORMANCE DIAGNOSIS",
        "INDIVIDUAL DEVELOPMENT PLAN",
        "TRAINING DESIGN",
        "MATCH PREPARATION",
        "PERFORMANCE REVIEW",
      ],
    },
    education: {
      eyebrow: "EDUCATION",
      title: "EDUCATION & QUALIFICATIONS",
    },
    references: {
      eyebrow: "REFERENCES",
      title: "PROFESSIONAL REFERENCES",
      privacy: "Professional references and direct contact information available upon request.",
      groups: { coach: "COACHING STAFF", management: "SPORTING MANAGEMENT" },
    },
    media: {
      eyebrow: "MEDIA",
      title: "INSIDE THE WORK",
      empty: "Media content coming soon.",
    },
    contact: {
      eyebrow: "CONTACT",
      title: "OPEN TO PROFESSIONAL FOOTBALL PROJECTS",
      body: "Available to connect with football clubs, coaching staffs and sporting organizations interested in goalkeeper development and high-performance environments.",
      sendEmail: "SEND EMAIL",
      whatsapp: "WHATSAPP",
      downloadCv: "DOWNLOAD CV",
      form: {
        name: "Name",
        organization: "Organization / Club",
        position: "Position",
        email: "Email",
        phone: "Phone",
        message: "Message",
        send: "SEND MESSAGE",
        success: "Message sent. Thank you for reaching out.",
        error: "Something went wrong. Please try again.",
      },
    },
    footer: {
      role: "PROFESSIONAL GOALKEEPER COACH",
      rights: "All rights reserved.",
    },
    admin: {
      login: "Sign in",
      loginTitle: "Admin Panel",
      email: "Email",
      password: "Password",
      logout: "Sign out",
    },
  },
};

export const pickBilingual = (obj, lang) => {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.es || obj.en || "";
};
